<template>
  <div class=" inline-flex items-center h-20">
    <!--  -->
    <div class="cursor-pointer" @click="back">
      <i class="el-icon-back text-lg mr-2" />
      <span class="text-base">Back</span>
    </div>
    <i class="inline-block border-r border-gray-300 h-5 mx-4" />
    <span class="text-lg">{{ $route.meta.title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    autoBack: {
      type: Boolean,
      default: true
    }
  },
  //
  methods: {
    back() {
      if (this.autoBack) {
        if (window.history.length > 1) {
          this.$router.back()
        } else {
          this.$router.replace('/product/myCart')
        }
      }
      this.$emit('back')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
